import { Animated } from 'react-native';

// Note: react-native-web's Animated API does not have Animated.loop.
// This is a util function for that. Note that this might not be optimal
// since JS is invoked every time the loop restarts.
export function loop(
  animation: Animated.CompositeAnimation,
  resetAnimation?: () => void,
): Animated.CompositeAnimation {
  // If we have Animated.loop (aka we're on native), just return that.
  if (!!Animated.loop) {
    return Animated.loop(animation);
  }

  let isRunning = true;
  // Otherwise, we do our own light version of the loop animation implementation found here:
  // https://github.com/facebook/react-native/blob/1151c096dab17e5d9a6ac05b61aacecd4305f3db
  //  /Libraries/Animated/src/AnimatedImplementation.js
  return {
    start() {
      const restart = () => {
        resetAnimation?.();
        animation.start(restart);
      };

      if (isRunning) {
        restart();
      }
    },

    stop() {
      animation.stop();
      isRunning = false;
    },

    reset() {
      resetAnimation?.();
    },
  };
}
